import React, { createContext, useState, useContext } from 'react';

// Create Context
export const WizardContext = createContext();

// Create Provider
export const WizardProvider = ({ children }) => {
  // State variables from Step1.js
  const [selectionOption, setSelectionOption] = useState("Vegefest");

  // State variables from Step2.js
  const [firstname, setFirstname] = useState(null);
  const [lastname, setLastname] = useState(null);
  const [chinesename, setChinesename] = useState(null);
  const [gender, setGender] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [event1, setEvent1] = useState(null);
  const [event2, setEvent2] = useState(null);
  const [headcountEvent1, setHeadcountEvent1] = useState(null);
  const [headcountEvent2, setHeadcountEvent2] = useState(null);

  // State variables from Step3.js
  // Define them similarly...
  // Example:
  const [confirmation, setConfirmation] = useState(false);

  // Functions to validate or manage the steps, if needed, can be defined here too.
  const isValidatedStep1 = () => {
    return selectionOption !== null;
  };

  const isValidatedStep2 = () => {
    // Add your validation logic for Step2 here
    return true;
  };

  const isValidatedStep3 = () => {
    // Add your validation logic for Step3 here
    return true;
  };

  // Export all state variables and setters
  return (
    <WizardContext.Provider
      value={{
        selectionOption, setSelectionOption,
        firstname, setFirstname,
        lastname, setLastname,
        chinesename, setChinesename,
        email, setEmail,
        phone, setPhone,
        confirmation, setConfirmation,
        event1, setEvent1,
        event2, setEvent2,
        headcountEvent1, setHeadcountEvent1,
        headcountEvent2,setHeadcountEvent2
      }}
    >
      {children}
    </WizardContext.Provider>
  );
};

// Custom hook for using the Wizard Context
export const useWizard = () => {
  const context = useContext(WizardContext);
  if (!context) {
    throw new Error('useWizard must be used within a WizardProvider');
  }
  return context;
};
